import React from 'react';
import { CheckboxProps, LabelProps } from '../../types';
import FlexBox from '../FlexBox';
import Label from '../Label';
import { FLEX_ALIGN } from '../../constants';
import styles from './index.module.css';

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
    ({ id, label, className = '', disabled, ...props }, ref) => (
        <FlexBox
            className={`${styles.wrap} ${disabled ? styles.disabled : ''}`}
            component={(labelProps: LabelProps) => (
                <Label htmlFor={id} {...labelProps} />
            )}
            align={FLEX_ALIGN.center}
        >
            <input
                id={id}
                type="checkbox"
                className={styles.input}
                ref={ref}
                disabled={disabled}
                {...props}
            />
            <div className={`${styles.checkmark} ${className}`} />
            {Boolean(label) && <div className={styles.label}>{label}</div>}
        </FlexBox>
    )
);

export default Checkbox;
